import React from 'react';
import 'react-modal-video/scss/modal-video.scss';

function Block3() {

    return (
            <section className="news-section homepage">
                <div className="auto-container">
                    <div className="sec-title text-center">
                        <h2 className="homepage">Un espace web personnalisé, <span>clés en main</span></h2>
                        <div className="text homepage">Un espace web dédié <span>à votre nom et à vos couleurs</span>, avec des contenus <span>personnalisés</span>, en complément de l’accès <span>aux experts et aux ressources utiles.</span></div>
                    </div>

                    <div className="row wow fadeInUp" style={{padding: "0 100px"}}>

                        <div className="news-block col-lg-6 col-md-6 col-sm-12">
                            <div className="inner-box">
                                <div className="image-box">
                                    <figure className="image homepage">
                                        <img src="/images/resource/calendrier.jpg" alt="calendrier" className="homepage"/>
                                    </figure>
                                </div>
                                <div className="lower-content homepage">
                                    <h3 className="homepage">Agenda de vos événements Handicap</h3>
                                    <p className="text">Affichez facilement vos événements inclusifs comme la SEEPH, Duoday, webinaires ou formations grâce à l’agenda intégré, pour informer et engager vos collaborateurs.</p>
                                </div>
                            </div>
                        </div>

                        <div className="news-block col-lg-6 col-md-6 col-sm-12">
                            <div className="inner-box">
                                <div className="image-box">
                                    <figure className="image homepage">
                                        <img src="/images/resource/centre-client.jpg" alt="centre-client" className="homepage"/>
                                    </figure>
                                </div>
                                <div className="lower-content homepage">
                                    <h3 className="homepage">Accès direct à notre équipe support</h3>
                                    <p className="text">Grâce au formulaire intégré, vos collaborateurs peuvent contacter l’équipe Talents Handicap pour poser leurs questions ou demander de l’assistance, avec une réponse rapide et personnalisée.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
    )
}

export default Block3;
